"use strict";

/**
* Модель записи прав доступа.
*
* @class AccessRightsEntryModel
* @since 5.8.2.4000
* @extends BaseObjectModel
 */

let AccessRightsEntryModel = BaseObjectModel.extend({

  /**
  * Инициализирует модель записи прав доступа.
  * @method AccessRightsEntryModel#init
  * @param {integer} principalId Идентификатор субъекта прав
  * @param {bool} isGroupPrincipal Признак того, что субъект прав является группой пользователей
  * @param {ACCESS_RIGHTS} rightsType Тип прав доступа
  */
  init(principalId, isGroupPrincipal, rightsType) {
    this._super();
    this.className = "AccessRightsEntryModel";

    this.principalId = principalId;
    this.isGroupPrincipal = isGroupPrincipal;
    this.rightsType = rightsType;
  }
});